import { setThemeColor } from './util.js';

const html = document.getElementsByTagName("html")[0];

html.classList.remove('no-js');

setThemeColor(html);
